class PromoPopup extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'lumin:promo-popup';

    this.classes = {
      bodyClass: 'promo-popup--open',
      activeClass: 'is-active',
      closingClass: 'is-closing',
      showImage: 'show-image'
    };

    this.popup = this.querySelector('.promo-popup');
    this.reminder = this.querySelector('.popup-floating');
    this.reminderCookieName = `${this.cookieName}:reminder-hidden`;
    this.reminderRequested = false;
    this.footerVisible = false;
    this.hasSubmitted = Boolean(this.querySelector('.form__message:not(.errors)'));
    this.handleKeydown = this.onKeydown.bind(this);

    // Open modal if errors or success message exist
    if (this.querySelector('.form__message')) {
      this.open();
    }

    

    this.querySelectorAll('.popup-close, .popup-overlay, .popup-dismiss').forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });

    this.querySelectorAll('.popup-open').forEach((button) => {
      button.addEventListener('click', this.open.bind(this));
    });

    const reminderClose = this.querySelector('.popup-floating__close');
    if (reminderClose) {
      reminderClose.addEventListener('click', this.dismissReminder.bind(this));
    }

    if (!this.querySelector('.form__message') && (!this.getCookie(this.cookieName) || this.dataset.testMode === 'true')) {
      this.init();
    } else if (!this.querySelector('.form__message')) {
      this.showReminder();
    }

    this.observeFooter();

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => filterShopifyEvent(event, this, () => this.open.bind(this)));
      document.addEventListener('shopify:section:select', (event) => filterShopifyEvent(event, this, this.open.bind(this)));
      document.addEventListener('shopify:section:deselect', (event) => filterShopifyEvent(event, this, this.close.bind(this)));
    }
  }

  init() {
    if (Shopify && Shopify.designMode) {
      return;
    }

    this.openTimer = setTimeout(function() {
      this.open();
    }.bind(this), parseInt(this.dataset.delay) * 1000);
  }

  open() {
    clearTimeout(this.openTimer);
    document.body.classList.remove(this.classes.bodyClass);
    const image = this.querySelector('.popup__image');
    if (image) {
      image.loading = 'eager';
      image.fetchPriority = 'high';
    }
    this.popup.classList.add(this.classes.activeClass, this.classes.showImage);
    this.syncReminder();
    document.addEventListener('keydown', this.handleKeydown);

    setTimeout(() => {
      this.querySelector('.popup-close')?.focus();
    }, 50);

    if (this.dataset.position === 'center') {
      setScrollbarWidth();
      document.body.classList.add(this.classes.bodyClass);
    }
  }

  close() {
    this.popup.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
      this.popup.classList.remove(this.classes.showImage);

      if (this.dataset.position === 'center') {
        document.body.classList.remove(this.classes.bodyClass);
      }

      document.removeEventListener('keydown', this.handleKeydown);

      if (!this.hasSubmitted) {
        this.showReminder();
      }
    }, 500);

    // Remove a cookie in case it was set in test mode
    if (this.dataset.testMode === 'true') {
      this.removeCookie(this.cookieName);
      return;
    }

    this.setCookie(this.cookieName, this.dataset.expiry);
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.popup.classList.contains(this.classes.activeClass)) {
      this.close();
    }
  }

  showReminder() {
    if (!this.reminder || this.hasSubmitted || this.getCookie(this.reminderCookieName)) {
      return;
    }

    this.reminderRequested = true;
    this.syncReminder();
  }

  dismissReminder() {
    this.reminderRequested = false;
    this.setCookie(this.reminderCookieName, this.dataset.expiry);
    this.syncReminder();
  }

  syncReminder() {
    if (!this.reminder) {
      return;
    }

    const shouldShow = this.reminderRequested
      && !this.footerVisible
      && !this.popup.classList.contains(this.classes.activeClass);

    clearTimeout(this.reminderHideTimer);

    if (shouldShow) {
      this.reminder.hidden = false;
      requestAnimationFrame(() => this.reminder.classList.add('is-visible'));
      return;
    }

    this.reminder.classList.remove('is-visible');
    this.reminderHideTimer = setTimeout(() => {
      if (!this.reminder.classList.contains('is-visible')) {
        this.reminder.hidden = true;
      }
    }, 180);
  }

  observeFooter() {
    if (!this.reminder || !('IntersectionObserver' in window)) {
      return;
    }

    const footer = document.querySelector('.bebe-room-footer, footer.footer');
    if (!footer) {
      return;
    }

    this.footerObserver = new IntersectionObserver((entries) => {
      this.footerVisible = entries[0].isIntersecting;
      this.syncReminder();
    }, { threshold: 0.05 });

    this.footerObserver.observe(footer);
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('promo-popup', PromoPopup);
